import { Trans } from '@lingui/react/macro';

import type { AudienceActivationType } from '@/api/audience';
import WidgetError from '@/components/errors/WidgetError';
import { Text } from '@/components/typography';
import { useWizardContext } from '@/components/wizard';

import { getAudienceActivationConsent } from './audience-activation-util';

const AudienceActivationConsentStep = () => {
  const { wizardData } = useWizardContext<{ activation: AudienceActivationType }>();
  const provider = wizardData.activation.provider;

  if (!provider) {
    return <WidgetError />;
  }

  return (
    <div className="flex flex-col gap-6">
      <Text variant="body2" weight="light" italic>
        <Trans>
          The following consent statement is provided and required by {provider.name}. Please direct
          any consent related questions to {provider.name}.
        </Trans>
      </Text>
      <Text variant="headline" weight="light">
        {getAudienceActivationConsent(provider)}
      </Text>
    </div>
  );
};

export default AudienceActivationConsentStep;
